import { Box, Typography } from '@mui/material';

export function MenuRow({
  caption,
  disabled,
  icon,
  label,
  onClick,
}: {
  caption?: string;
  disabled?: boolean;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <Box
      alignItems="center"
      component="button"
      disabled={disabled}
      display="flex"
      gap={1.5}
      onClick={onClick}
      padding={1.5}
      sx={{
        bgcolor: 'transparent',
        border: 'none',
        borderRadius: 2,
        color: '#374151',
        cursor: 'pointer',
        textAlign: 'left',
        width: '100%',
        '&:disabled': { cursor: 'default', opacity: 0.5 },
        '&:hover:not(:disabled)': { bgcolor: '#F3F6FF' },
        '&:hover:not(:disabled) .menu-row-icon': { color: '#326AC2' },
      }}
    >
      <Box className="menu-row-icon" color="#6B7280" display="flex" flexShrink={0}>
        {icon}
      </Box>
      <Box display="flex" flexDirection="column">
        <Typography fontSize={14} fontWeight={500}>
          {label}
        </Typography>
        {caption && (
          <Typography color="text.secondary" fontSize={12}>
            {caption}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
